<template>
  <div>
    <v-head></v-head>
    <div class="more_bg">
      <img src="../assets/pic02.png" alt="">
      <div class="more_txt">
        <div class="title">
          信息化产品
        </div>
        <div class="txt">
          morematization Products
        </div>
      </div>
    </div>
    <div class="more_content">
      <div class="more_left">
        <img src="../assets/p11.png" alt="">
      </div>
      <div class="more_right">
        <div class="maxTitle">基于RFID的接地线管理系统</div>
        <div class="more_wrap">
          <div class="title">产品介绍</div>
          <div class="txt">
            基于RFID的接地线管理系统具有准实时性、轻组态、高可靠等特点，可在电站环
            境内监测接地点上是否接入接地线；对接地线的管理（包括质检日期是否即将到
            期、接地线接入接地点日志查看等），通过RFID物联网的采集和数据传输，满足
            了工作人员对接地点是否接入接地线的联网监控管理需求，让运维人员实时掌控
            电站内机房运行安全。
          </div>
          <div class="title">相关案例</div>
          <div class="introimg">
             <img src='../assets/p12.png' alt="" >
             <div class="intro" @click="gotoDetail">
              <span class="el-icon-right" ></span>
             </div>
          </div>
          
          <div class="txt last">基于RFID的接地线管理系统</div>
        </div>
      </div>
    </div>
    <div class="more_detail">
      <div class="title_wrap">
        <div class="title">
          产品详情
        </div>
        <div class="mini_title">
          DETAILS
        </div>
      </div>
      <div class="box">
        <div class="more_top">
          <div class="more_list">
            <div class="title">集中监控</div>
            <div class="en">Centralized monitoring</div>
            <div class="txt"><span class="el-icon-caret-right"></span>站内所有接地点状态，接地线状态统一监控。</div>
            
          </div> 
          <div class="more_list">
            <div class="title">远程访问</div>
            <div class="en">Remote access</div>
            <div class="txt"><span class="el-icon-caret-right"></span>支持web网页、微信小程序远程访问，方便用户在任何时候任何位置都可以随时访问系统。</div>
          </div>
          <div class="more_list end">
            <div class="title">预警提示</div>
            <div class="en">Warning prompt</div>
            <div class="txt"><span class="el-icon-caret-right"></span>当接地线质检日期将过时或接地点上还接入着接地线，都会提示用户，最大程度抑制故障的发生。</div>
          </div>
          
        </div>
        <div class="more_bottom">
          <div class="more_list">
            <div class="title">信息化管理</div>
            <div class="en">Information management</div>
            <div class="txt"><span class="el-icon-caret-right"></span>对设备的信息管理全部以数字化的方式展现出来，包括对日志的查看、更新设备等。</div>
          </div> 
        </div>
      </div>
    </div>
    <div class="more_down">
      <div class="title_wrap">
        <div class="title">
          相关下载
        </div>
        <div class="mini_title">
          DOWNLOAD
        </div>
      </div>
      <div>
        <img src="../assets/code1.jpg" alt="">
      </div>
    </div>
    <v-foot class="more_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    },
    gotoDetail() {
      router.push('/detail')
    },
  }
}
</script>
<style scoped>
.introimg{
  display: flex;
    align-items: center;
}
.intro {
  text-align: center;
  width: 75px;
  height: 35px;
  line-height: 35px;
  background: #f5a93e;
  border-radius: 4px 4px 4px 4px;
  color: #FFFFFF ;
  margin-left: 30px;
  /* margin: 0 auto; */
  }
.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.more_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.more_txt {
  position: absolute;
  top: 280px;
  right: 420px;
  color: #fff ;
}
.more_txt .title {
  font-size: 58px;
}
.more_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.more_text {
  display: flex;
}

.more_content {
  display: flex;
  margin-top: 30px;
  justify-content: center;
  width: 70%;
  align-items: center;
  margin: 0 auto;
  padding-top: 80px;
}
.more_left img{
  width: 420px;
  height: 360px;
}
.more_right {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 50px;
}
.more_right .maxTitle {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}
.more_right .title {
  margin: 15px 0;
  font-size: 22px;
  color: #333;
  font-weight: 600;
}
.more_right .txt {
  font-size: 15px;
  color: #333;
}
.more_wrap {
  width: 550px;
  border-top: 1px solid #333;
  margin: 15px 0;
}
.more_wrap .last {
  margin-top: 10px;
}
.more_detail {
  width: 1000px;
  margin: 0 auto;
}
.more_detail .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
}
.more_detail .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_detail .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_detail .more_top {
  display: flex;
}
.more_top .more_list {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 300px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 20px 10px;
}
.more_detail .end {
  margin-right: 0;
}
.more_detail .more_list .title {
  font-size: 18px;
  font-weight: 600;
}
.more_detail .more_list .en {
  font-size: 14px;
  padding: 10px 0;
  color: #bbb;
}
.more_detail .more_list .txt {
  font-size: 14px;
  color: #333;
  display: flex;
}
.el-icon-caret-right {
  margin-top: 5px;
  color: #333;
}
.more_detail .more_bottom {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 280px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 30px;
  padding: 30px 10px;


}
.more_down {
  width: 1000px;
  margin: 0 auto;
}
.more_down .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
  margin-top: 60px;
}
.more_down .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_down .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_foot {
  margin-top: 50px;
}

</style>


// WEBPACK FOOTER //
// src/components/MoreInfor.vue